
import {Component, Vue, Watch} from "vue-property-decorator";
import Songs from "@/components/SongList.vue";
import {store} from '../Store';

@Component({
    components: {
        Songs,
    },
})
export default class Home extends Vue {
    data = store.data;

    created() {
        this.changeSearch();
        store.cleanCurrents();
    }

    @Watch('$route')
    changeSearch() {
        this.data.currentFilter = this.$route.query['q'] || '';
        if (this.data.currentFilter) {
            this.data.searchingMode = true;
        }
    }
}
